<template>
	<page-two-columns class="view-not-found" sticky="left" v-bind="{ division }">
		<template #left>
			<page-header :reserve-vertical-space="false">404</page-header>
		</template>

		<template #right>
			<app-card>
				<p class="view-not-found__text">
					There’s no page you are looking for.
					<br />
					But there’s still hope!
				</p>

				<template #footer>
					<base-button class="view-not-found__back-button" size="small" :to="{ name: 'home' }">
						Back to home
					</base-button>
				</template>
			</app-card>
		</template>
	</page-two-columns>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import AppCard from '@/components/app/AppCard.vue';
import PageHeader from '@/components/page/PageHeader.vue';
import PageTwoColumns, { GridDivision } from '@/components/page/PageTwoColumns.vue';

export default defineComponent({
	components: {
		AppCard,
		PageTwoColumns,
		PageHeader,
	},

	data() {
		return {
			division: GridDivision.OneFourth,
		};
	},
});
</script>

<style lang="scss">
.view-not-found {
	.page-header__heading {
		padding-left: 1.2rem;
	}

	.page-two-columns-column__content {
		padding: 7.5rem 0 12rem;
	}

	&__text {
		@include heading-2;
		padding-top: 0.5rem;
		letter-spacing: 0.035em;
	}

	&__back-button.base-button {
		width: 14.8rem;
		height: 4.8rem;
		margin-left: auto;
		padding-right: 1rem;
		padding-left: 1rem;
		color: $color-primary;
	}
}
</style>
